import { toast } from "react-toastify";
import { parseAmount } from "../services/utils";
import useApiService from "./useApiService";

const useCoupon = () => {
  const { get, post } = useApiService();

  const createNewCoupon = async (data) => {
    try {
      const response = await post("/api/coupons", data);
      if (response.status) {
        return {
          coupon: {
            id: response.coupon_id,
            code: response.coupon_code,
          },
        };
      } else {
        throw new Error("Unable to create new coupon");
      }
    } catch (error) {
      toast.error("Unable to create new coupon. Make sure the agent ids are correct");
      return { error };
    }
  };

  const regenerateCoupon = async (id) => {
    try {
      const response = await get(`/api/coupon/${id}/regenerate`);
      if (response.status) {
        return {
          coupon: {
            code: response.coupon_code,
          },
        };
      } else {
        throw new Error("Unable to regenerate coupon");
      }
    } catch (error) {
      return { error };
    }
  };

  const calculateCouponEndTime = (createdAt, validFor) => {
    const [hours, minutes] = validFor.split(":");
    const validForMinutes = parseInt(hours) * 60 + parseInt(minutes);
    const [createdDay, createdMonth, createdYear] = createdAt.split(" ")[0].split("-");
    const createdAtTime = createdAt.split(" ")[1];
    const createdAtDate = new Date(
      createdYear,
      createdMonth - 1,
      createdDay,
      createdAtTime.split(":")[0],
      createdAtTime.split(":")[1]
    );
    const endTime = new Date(createdAtDate.getTime() + validForMinutes * 60 * 1000);
    const isExpired = endTime < new Date();
    return { expires_at: endTime, isExpired };
  };

  const fetchAllCoupons = async () => {
    try {
      const response = await get("/api/coupons");
      if (response.status && response.data) {
        const { data } = response;
        const coupons = data.map((coupon) => ({
          date: coupon.date.split(" ")[0].split("-").join("/"),
          id: coupon.coupon_id,
          agents: coupon.agents.length === 0 ? "All Agents" : coupon.agents.join(", "),
          number_of_uses: coupon.number_of_uses,
          code: coupon.coupon_code,
          discount: parseAmount(coupon.discount),
          expiry: calculateCouponEndTime(coupon.date, coupon.expiry_time),
        }));
        const validCoupons = { coupons: coupons.filter((coupon) => coupon.expiry.isExpired === false) };
        return validCoupons;
      } else {
        throw new Error("Unable to fetch coupons");
      }
    } catch (error) {
      return { error };
    }
  };

  return { createNewCoupon, regenerateCoupon, fetchAllCoupons };
};

export default useCoupon;
